import { PageWrapper } from 'layout/PublicLayout/Wrappers';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import SiteDetailsView from './SiteDetailsView';
import SitesView from './SitesView';

const LoadingFallback = () => {
    const { t } = useTranslation();

    return <div>{t('Loading')}</div>;
};

export const PublicSitesView = () => (
    <PageWrapper>
        <Suspense fallback={<LoadingFallback />}>
            <SitesView />
        </Suspense>
    </PageWrapper>
);

export const PublicSiteDetailsView = () => (
    <PageWrapper>
        <Suspense fallback={<LoadingFallback />}>
            <SiteDetailsView />
        </Suspense>
    </PageWrapper>
);

export default { PublicSitesView, PublicSiteDetailsView };
